import React from 'react';
import { motion } from 'framer-motion';
import { BsArrowRight } from "react-icons/bs";
import { Link } from 'gatsby';
import "./BannerStyles.scss";

const Banner = () => {
    const animateInitial = {
        opacity: 0,
        y: 20,
    };
    const animateFinal = {
        opacity: 1,
        y: 0,
    };

    return (
        <div className="banner">
            <div className="content">
                <motion.div 
                    className="main-text"
                    initial={animateInitial}
                    animate={animateFinal}
                    transition={{duration: 1, delay: 1.25, ease: "easeOut"}}
                >
                    <h1>
                        Hello, I'm Yousef. Systems developer & Student living at the intersection of software and design.
                    </h1>
                </motion.div>
                <motion.div 
                    initial={animateInitial}
                    animate={animateFinal}
                    transition={{duration: 1, delay: 1.35, ease: "easeOut"}}
                >
                    <Link to="/about" className='learn-more hover-underline-animation'>
                        More about me <span><BsArrowRight /></span>
                    </Link>
                </motion.div>
            </div>
        </div>
    );
};

export default Banner;